import { graphql } from "gatsby"
import React from "react"
import "twin.macro"
import PreHeader from "../../atoms/pre-header"
import Sandbox from "../../atoms/sandbox"
import WaterfallMedia from "./watefall-media"
import ContentWrapper from "../../atoms/content-wrapper"
import { themeStyles } from "../../../styles/theme-helpers"

const Waterfall = ({ data }) => {
  const theme = data.theme?.name || "mist"
  return (
    <div
      tw="relative flex justify-end pt-8 px-6 pb-32 sm:px-12 md:px-16 lg:(px-20 pt-16) xl:(px-32 pt-20) xl:pb-48"
      css={themeStyles[theme]}
      className={`tear-t-sm-${theme} tear-b-sm-${theme}`}
    >
      <ContentWrapper tw="relative  sm:(flex flex-wrap justify-center items-center)  xl:justify-between">
        <div tw="sm:(w-1/2 mb-8) xl:(w-3/5 mb-16)">
          {data.header && <PreHeader>{data.header}</PreHeader>}
          {data.title && (
            <h3 tw="font-display text-4xl mb-4 xl:text-6xl">{data.title}</h3>
          )}
          {data.text && (
            <Sandbox
              tw="text-sm mb-4 pr-4 xl:text-base"
              dangerouslySetInnerHTML={{ __html: data.text }}
            />
          )}
        </div>
        {data.media_element.map((item, index) => (
          <WaterfallMedia key={item.id} item={item} index={index} />
        ))}
      </ContentWrapper>
    </div>
  )
}

export const fragment = graphql`
  fragment Waterfall on FT_ComponentOrganismsWaterfall {
    id
    title
    text
    header
    theme {
      name
    }
    media_element {
      ...WaterfallMedia
    }
  }
`

export default Waterfall
